import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { isPublicHomeAllowed } from '../../utils/publicHome';

/**
 * Gegenstück zu `ProtectedRoute`: Diese Seite ist nur für NICHT angemeldete
 * Besucher gedacht. Wer angemeldet ist, landet in seinem Bereich.
 *
 * Gebraucht für „Mitglied werden" - ein angemeldetes Mitglied, das den alten
 * Link aus einem Lesezeichen aufruft, soll keine Registrierungs-Werbung
 * sehen, sondern dort ankommen, wo es hinwollte - und für die Startseite:
 * Sie ist die Seite für Gäste und Interessenten, Mitglieder gehören in ihre
 * Club-Zentrale.
 *
 * Der `loading`-Zweig ist Pflicht, nicht Kosmetik: Solange der Auth-Zustand
 * nicht feststeht, ist `user` null - ohne den Spinner würde die Seite für ein
 * angemeldetes Mitglied kurz aufblitzen und dann wegspringen.
 *
 * `showWhileLoading` ist die Ausnahme davon, und sie gilt genau für die
 * Startseite. Deren Inhalt ist die EINZIGE eager gebündelte Route - damit der
 * erste Eindruck sofort steht. Ein Spinner dort träfe jeden Besucher,
 * Suchmaschinen eingeschlossen, und das wäre ein schlechter Tausch gegen ein
 * kurzes Aufblitzen. Der Unterschied zu „Mitglied werden": Dort ist der
 * aufblitzende Inhalt für ein Mitglied inhaltlich falsch, die Clubstartseite
 * kurz zu sehen ist es nicht.
 *
 * `allowEscape` lässt den Ausgang aus utils/publicHome.js gelten: Über den
 * Menüeintrag „Öffentliche Seite" darf ein Mitglied die Startseite ansehen -
 * sonst wäre sie für Angemeldete gar nicht erreichbar.
 */
export default function PublicOnlyRoute({
  children,
  to = '/intern',
  showWhileLoading = false,
  allowEscape = false,
}) {
  const { user, loading } = useAuth();

  if (loading) {
    if (showWhileLoading) return children;
    return (
      <div className="mt-loading">
        <div className="mt-spinner" />
      </div>
    );
  }

  if (user && !(allowEscape && isPublicHomeAllowed())) {
    return <Navigate to={to} replace />;
  }

  return children;
}
